import React, { useRef } from 'react';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',

    width: '95%',
    maxWidth: '700px',

    maxHeight: '95vh',
    overflow: 'auto',

    padding: '16px',
    borderRadius: '12px',
  },

  overlay: {
    background: 'rgba(0,0,0,0.5)',
    zIndex: 9999,
  },
};

const ImageUploadModal = ({
  modalOpen,
  onClose,
  fileOpen,
  onCroped,
  identifier,
  imgHeight = 500,
  imgWidth = 500,
}) => {

  const cropperRef = useRef(null);

  const onCropCompleted = () => {

    const cropper = cropperRef.current?.cropper;

    if (!cropper) return;

    onCroped(
      cropper.getCroppedCanvas().toDataURL(),
      identifier
    );

    onClose();
  };

  return (
    <Modal
      ariaHideApp={false}
      isOpen={modalOpen}
      onRequestClose={onClose}
      style={customStyles}
      contentLabel="Image Cropper"
    >

      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-bold">
          Atur Foto
        </h2>

        <button onClick={onClose}>
          <FontAwesomeIcon icon={faClose} />
        </button>
      </div>

      <div
        style={{
          width: '100%',
          height: '60vh',
        }}
      >
        <Cropper
          ref={cropperRef}
          src={fileOpen}
          style={{
            width: '100%',
            height: '100%',
          }}
          aspectRatio={imgWidth / imgHeight}
          guides={true}
          viewMode={1}
          responsive={true}
          autoCropArea={1}
          checkOrientation={false}
        />
      </div>

      <div className="mt-4 flex justify-end">
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          onClick={onCropCompleted}
        >
          Selesai
        </button>
      </div>

    </Modal>
  );
};

export default ImageUploadModal;

// import React, { useRef } from 'react';
// import Cropper from 'react-cropper';
// import 'cropperjs/dist/cropper.css';
// import Modal from 'react-modal';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faClose } from '@fortawesome/free-solid-svg-icons'

// const customStyles = {
//   content: {
//     top: '50%',
//     left: '50%',
//     right: 'auto',
//     bottom: 'auto',
//     marginRight: '-50%',
//     transform: 'translate(-50%, -50%)',
//   },
//   overlay: {
//     background: 'rgba(0, 0, 0, 0.5)'
//   }
// };


// const ImageUploadModal = ({ modalOpen, onClose, fileOpen, onCroped, identifier, imgHeight = 500, imgWidth = 500 }) => {
//   const cropperRef = useRef(null);

//   const onCropCompleted = () => {
//     const cropper = cropperRef.current?.cropper;
//     onCroped(cropper.getCroppedCanvas().toDataURL(), identifier);
//     onClose();
//   };

//   return (
//     <Modal
//       ariaHideApp={true}
//       isOpen={modalOpen}
//       onRequestClose={onClose}
//       style={customStyles}
//       contentLabel="Example Modal"
//     >
//       <button onClick={onClose} style={{ float: 'right' }}>
//         <FontAwesomeIcon icon={faClose} />
//       </button>

//       <div className="modal mt-6">
//         <div className="modal-content mb-4">
//           <h2 className="mb-2">Atur Foto</h2>
//           <div className="cropper-container">
//             <Cropper
//               style={{ height: imgHeight, width: imgWidth }}
//               ref={cropperRef}
//               src={fileOpen}
//               alt="Crop File"
//               aspectRatio={imgWidth/imgHeight}
//               guides={true}
//               // crop={onCropCompleted}
//             />

//           </div>
//         </div>
//         <button style={{ float: 'right' }} className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" onClick={onCropCompleted}>Selesai</button>
//       </div>

//     </Modal>
//   );
// };

// export default ImageUploadModal;
